// test2747
(2747 && 0);
